{
	"shell": {
		"nav": "Your pages",
		"signOut": "Sign out",
		"tabs": {
			"profile": "Profile",
			"events": "My events",
			"medals": "My medals"
		}
	},
	"profile": {
		"title": "Profile",
		"photoAlt": "Your accreditation photo",
		"noPhoto": "No photo yet",
		"cardsTitle": "Your cards",
		"cardsHint": "Your organisation registers and updates these. Ask them if something is wrong.",
		"noCards": "No cards yet.",
		"loadFailed": "Your profile could not be loaded.",
		"retry": "Try again",
		"contactTitle": "Contact details",
		"contactHint": "Only you and the Games organisers see these. Your name, ID and photo are changed by your organisation.",
		"emergencyTitle": "Emergency contact",
		"fields": {
			"email_address": "Email",
			"phone_country_code": "Country code",
			"phone_number": "Phone number",
			"residential_address": "Home address",
			"emergency_contact_name": "Name",
			"emergency_contact_relationship": "Relationship",
			"emergency_phone_country_code": "Country code",
			"emergency_phone_number": "Phone number"
		},
		"save": "Save changes",
		"saved": "Contact details saved.",
		"unchanged": "Nothing changed.",
		"stale": "Your details were changed somewhere else. The latest version is shown; make your change again.",
		"saveFailed": "Your contact details could not be saved.",
		"tiles": {
			"title": "At a glance",
			"nextUp": "Next up",
			"live": "Live now",
			"venueTbc": "Venue to be confirmed",
			"nothingScheduled": "Nothing scheduled yet",
			"medals": "Medals",
			"medal": {
				"GOLD_one": "{{count}} gold medal",
				"GOLD_other": "{{count}} gold medals",
				"SILVER_one": "{{count}} silver medal",
				"SILVER_other": "{{count}} silver medals",
				"BRONZE_one": "{{count}} bronze medal",
				"BRONZE_other": "{{count}} bronze medals"
			},
			"medalsTotal_one": "{{count}} medal",
			"medalsTotal_other": "{{count}} medals",
			"noMedals": "No medals yet",
			"loadFailed": "Could not load this."
		},
		"contact": {
			"edit": "Edit",
			"cancel": "Cancel",
			"notGiven": "Not given",
			"phone": "Phone"
		}
	},
	"status": {
		"DRAFT": "Draft",
		"SUBMITTED": "Submitted",
		"PENDING": "Pending",
		"APPROVED": "Approved",
		"RETURN": "Returned",
		"REJECTED": "Rejected",
		"WITHDRAWN": "Withdrawn"
	},
	"events": {
		"title": "My events",
		"empty": "You are not entered in any event yet.",
		"emptyHint": "Your NOC enters you. Events appear here as soon as they do.",
		"loadFailed": "Your events could not be loaded.",
		"primary": "Primary",
		"reserve": "Reserve",
		"entered": "Entered",
		"noSchedule": "Not scheduled yet",
		"venueTbc": "Venue to be confirmed",
		"rank": "Rank {{rank}}",
		"cancelled": "Cancelled",
		"live": "Live",
		"official": "Official",
		"unofficial": "Unofficial",
		"previous": "Previous",
		"next": "Next",
		"pageOf": "Page {{page}} of {{pages}}",
		"retry": "Try again",
		"loadFailedHint": "Check your connection and try again.",
		"sessions_one": "{{count}} session",
		"sessions_other": "{{count}} sessions",
		"nextUp": "Next up",
		"postponed": "Postponed",
		"delayed": "Delayed",
		"interrupted": "Interrupted",
		"eventOfSport": "{{sport}}, {{event}}",
		"unscheduledHint": "Times appear here once the schedule is set."
	},
	"medals": {
		"title": "My medals",
		"empty": "No medals yet.",
		"emptyHint": "A medal shows here once it is awarded.",
		"loadFailed": "Your medals could not be loaded.",
		"GOLD": "Gold",
		"SILVER": "Silver",
		"BRONZE": "Bronze",
		"count_one": "{{count}} medal",
		"count_other": "{{count}} medals",
		"awardedOn": "Awarded {{date}}",
		"retry": "Try again",
		"loadFailedHint": "Check your connection and try again.",
		"tallyLabel": "Your medal tally",
		"total": "Total"
	}
}
